import { useParams } from 'react-router-dom';

import { AppSearchPage } from '~/components/pages/AppSearchPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppSearchRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppSearchPage appId={appId} />
    </DashboardTemplate>
  );
};
